import {
  Component,
  Input,
  HostBinding,
  Output,
  EventEmitter,
  OnInit,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'suka-card',
  template: `
    <suka-card-header
      *ngIf="title"
      (action)="onHeaderAction($event)"
      [actionLabel]="headerActionLabel"
      [skeleton]="skeleton"
    >
      {{title}}
    </suka-card-header>

    <suka-card-section
      *ngIf='(sectioned !== false) else elseTpl'
    >
      <ng-container *ngTemplateOutlet="elseTpl"></ng-container>
    </suka-card-section>

    <suka-card-footer
      *ngIf='!skeleton && showFooter'
      (primaryAction)="onPrimaryFooterAction($event)"
      [primaryLabel]="primaryFooterActionLabel"
      (secondaryAction)="onSecondaryFooterAction($event)"
      [secondaryLabel]="secondaryFooterActionLabel"
    >
    </suka-card-footer>

    <ng-template #elseTpl><ng-content></ng-content></ng-template>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class Card implements OnInit {
  /**
   * Title content for the card.
   */
  @Input() title: string;

  /**
   * Set to `true` to auto-wrap content in section
   */
  @Input() sectioned: boolean;

  /**
   * Primary action label.
   */
  @Input() primaryFooterActionLabel: string;
  /**
   * Callback for the primary action
   */
  @Output() primaryFooterAction = new EventEmitter();

  /**
   * Secondary action label.
   */
  @Input()  secondaryFooterActionLabel: string;
  /**
   * Callback for the secondary action
   */
  @Output() secondaryFooterAction = new EventEmitter();

  /**
   * Card header action label
   */
  @Input() headerActionLabel: string;

  /**
   * Callback for the card header action
   */
  @Output() headerAction = new EventEmitter();

  @HostBinding('class.card') cardClass = true;

  /**
   * Set to `true` to display a loading card.
   */
  @Input() skeleton = false;

  /**
   * Display footer state.
   */
  showFooter = false;

  public ngOnInit() {
    this.showFooter = this.primaryFooterAction.observers.length > 0;
  }

  /**
   * Emits the cards primary footer action callback
   */
  public onPrimaryFooterAction($event) {
    this.primaryFooterAction.emit($event);
  }

  /**
   * Emits the cards secondary footer action callback
   */
  public onSecondaryFooterAction($event) {
    this.secondaryFooterAction.emit($event);
  }

  /**
   * Emits the cards header action callback
   */
  public onHeaderAction($event) {
    this.headerAction.emit($event);
  }
}
